'use strict';

/* Views */
import InvitedUserList from './invited-user-list/invited-user-list.component';
import RequestedUserList from './requested-user-list/requested-user-list.component';
import UserList from './user-list';

/* Services */
import RequestedUserService from '../../services/requested-user/requested-user.service';

/* Module */
export default angular.module('conduu.ap.admin', [InvitedUserList, RequestedUserList, UserList, RequestedUserService])
  .name;



// WEBPACK FOOTER //
// ./client/~ap/app/admin/index.js